import React from 'react'
import './snow.scss'

export default function Snow() {
  return (
      <>
        <div className="snow1"></div>
        <div className="snow2"></div>
      </>
    
  )
}
